module.exports = __webpack_public_path__ + "static/img/11.7889a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zddcf/11.png
// module id = 0ubH
// module chunks = 0